import {
  FeaturePageProps,
  getLandingPageData,
} from "@/ssr/features"
import { wrapSSRAuth } from "@/utils/ssr-auth"
import FeaturePage from "../feature/[feature]"
export default FeaturePage

export const getServerSideProps =
  wrapSSRAuth<FeaturePageProps>(async function (context) {
    const feature = String(context.params?.feature)

    const props = await getLandingPageData(
      feature,
      null,
      "tools"
    )

    return props
  }, [])
